// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cardParams {
  /* min-width: 396px;
  height: 208px;
  border-radius: 20px;
  padding: 24px;
  position: relative;
  overflow: hidden;
  cursor: pointer;

  flex-grow: 1;
  flex-basis: 0; */
  height: 208px;
  border-radius: 20px;
  padding: 24px;
  position: relative;
  overflow: hidden;
  cursor: pointer;
}

.cardParams:hover {
  box-shadow: rgba(0, 102, 204, 0.35) 0px 5px 15px;
}

.cardsContainer {
  display: flex;
  flex-wrap: wrap; /* so cards wrap if not enough space */
  gap: 16px; /* spacing between cards */
}

.newBox {
  width: 55px;
  height: 35px;
  background-color: var(--background_blue);
  position: absolute;
  left: -5px;
  top: 0px;
  border-bottom-right-radius: 8px;
}

.cardIcon {
  background-color: #f4f7fe;
  border-radius: 50%;
  width: 56px;
  height: 56px;
  margin-right: 20;
}

.authorName {
  border-radius: 40px;
  background: var(--background_blue);
  height: 27px;
  color: var(--uni_std_clr);
}

.rightSideIcon {
  position: absolute;
  right: 10px;
  top: 10px;
  /* visibility: 'hidden'; */
  display: none;
}

.cardParams:hover .rightSideIcon {
  display: block;
}
.threeDotIcon {
  visibility: hidden;
}

.cardParams:hover .threeDotIcon {
  visibility: initial;
}
`, "",{"version":3,"sources":["webpack://./src/components/Card.css"],"names":[],"mappings":"AAAA;EACE;;;;;;;;;kBASgB;EAChB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,eAAe,EAAE,sCAAsC;EACvD,SAAS,EAAE,0BAA0B;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,wCAAwC;EACxC,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kCAAkC;EAClC,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".cardParams {\n  /* min-width: 396px;\n  height: 208px;\n  border-radius: 20px;\n  padding: 24px;\n  position: relative;\n  overflow: hidden;\n  cursor: pointer;\n\n  flex-grow: 1;\n  flex-basis: 0; */\n  height: 208px;\n  border-radius: 20px;\n  padding: 24px;\n  position: relative;\n  overflow: hidden;\n  cursor: pointer;\n}\n\n.cardParams:hover {\n  box-shadow: rgba(0, 102, 204, 0.35) 0px 5px 15px;\n}\n\n.cardsContainer {\n  display: flex;\n  flex-wrap: wrap; /* so cards wrap if not enough space */\n  gap: 16px; /* spacing between cards */\n}\n\n.newBox {\n  width: 55px;\n  height: 35px;\n  background-color: var(--background_blue);\n  position: absolute;\n  left: -5px;\n  top: 0px;\n  border-bottom-right-radius: 8px;\n}\n\n.cardIcon {\n  background-color: #f4f7fe;\n  border-radius: 50%;\n  width: 56px;\n  height: 56px;\n  margin-right: 20;\n}\n\n.authorName {\n  border-radius: 40px;\n  background: var(--background_blue);\n  height: 27px;\n  color: var(--uni_std_clr);\n}\n\n.rightSideIcon {\n  position: absolute;\n  right: 10px;\n  top: 10px;\n  /* visibility: 'hidden'; */\n  display: none;\n}\n\n.cardParams:hover .rightSideIcon {\n  display: block;\n}\n.threeDotIcon {\n  visibility: hidden;\n}\n\n.cardParams:hover .threeDotIcon {\n  visibility: initial;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
